module.exports = __webpack_public_path__ + "static/media/IMG_20180315_183531.43a4a259.webp";